document.addEventListener("DOMContentLoaded", function () {
  const headerContainer = document.querySelector(".header__container");
  if (!headerContainer) return;

  const replayWorldWrapper = document.createElement("div");
  replayWorldWrapper.className = "replay-world-flyout";
  replayWorldWrapper.innerHTML = `
    <div class="replay-world-button">Replay World</div>
    <div class="replay-world-dropdown">
      <!--<a href="#" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/Nuovo_progetto_28_.jpg" alt="Collab">
        <span>COLLAB</span>
      </a>-->
      <a href="/collections/9zero1" class="replay-tile">
        <img src="https://cdn.shopify.com/s/files/1/0816/4199/6631/files/replay-world-9zero1.webp?v=1782817385" alt="9ZERO1">
        <span>9ZERO1</span>
      </a>
      <!--<a href="#" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/Replay_World_Image_-_390x400.jpg" alt="Fragrances">
        <span>FRAGRANCES</span>
      </a>
      <a href="#" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/NEW_CONTENT_UPDATE/390x400-2.jpg" alt="Sustainability">
        <span>SUSTAINABILITY</span>
      </a>-->
      <a href="/pages/dna" class="replay-tile">
        <img src="https://cdn.shopify.com/s/files/1/0816/4199/6631/files/replay-world-dna.jpg?v=1782817387" alt="DNA">
        <span>DNA</span>
      </a>
    </div>
  `;

  // Vložit vlevo do header containeru
  headerContainer.insertBefore(replayWorldWrapper, headerContainer.firstChild);
});
